import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type {
  Finding,
  FindingStatus,
  InsightDashboardData,
  KillChainPhase,
} from '../data-layer/insightDashboardTypes';

export type ClusterId = 'recon' | 'privilege' | 'financial' | null;

export interface InsightDashboardState {
  data: InsightDashboardData | null;
  isLoading: boolean;
  isError: boolean;
  errorReason: string;
  phaseFilter: KillChainPhase | 'ALL';
  selectedSession: string;
  selectedCluster: ClusterId;
  findings: Finding[];
}

const initialState: InsightDashboardState = {
  data: null,
  isLoading: true,
  isError: false,
  errorReason: '',
  phaseFilter: 'ALL',
  selectedSession: 'all',
  selectedCluster: null,
  findings: [],
};

const insightDashboardSlice = createSlice({
  name: 'aag/insightDashboard',
  initialState,
  reducers: {
    setData(state, action: PayloadAction<InsightDashboardData>) {
      state.data = action.payload;
      state.findings = action.payload.findings;
      state.isLoading = false;
      state.isError = false;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.isError = true;
      state.errorReason = action.payload;
      state.isLoading = false;
    },
    setPhaseFilter(state, action: PayloadAction<KillChainPhase | 'ALL'>) {
      state.phaseFilter = action.payload;
    },
    setSelectedSession(state, action: PayloadAction<string>) {
      state.selectedSession = action.payload;
    },
    setSelectedCluster(state, action: PayloadAction<ClusterId>) {
      state.selectedCluster = action.payload;
    },
    updateFindingStatus(
      state,
      action: PayloadAction<{ id: number; status: FindingStatus }>
    ) {
      const { id, status } = action.payload;
      const finding = state.findings.find((f) => f.id === id);

      if (finding) {
        finding.status = status;
      }
    },
  },
});

export const insightDashboardActions = insightDashboardSlice.actions;
export const insightDashboardReducer = insightDashboardSlice.reducer;

export default insightDashboardReducer;
